import { FC } from 'react';
import styled from 'styled-components';
import { configuration, PasswordRequirements as PasswordRequirementsType } from '../../services/Password';
import RequirementItem from './RequirementItem';

const Heading = styled.h3(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-size: ${type.size.regular};
    margin-bottom: 0.5rem;
    font-weight: ${type.weight.regular};
  `;
});

const RequirementList = styled.ul`
  margin-bottom: 2rem;
`;

export interface IPasswordRequirements {
  requirements: PasswordRequirementsType;
  className?: string;
}

const PasswordRequirements: FC<IPasswordRequirements> = ({ className, requirements }) => {
  const { username, firstName, lastName, blockedWords, symbol, uppercase, lowercase, number, length } = requirements;
  const { minLength, symbolList } = configuration;
  const blockedWordsArray = configuration.blockedWords;

  return (
    <div className={className}>
      <Heading>Password requirements:</Heading>

      <RequirementList>
        <RequirementItem valid={length}>Must be at least {minLength} characters.</RequirementItem>
        <RequirementItem valid={uppercase}>Must contain at least 1 uppercase letter</RequirementItem>
        <RequirementItem valid={lowercase}>Must contain at least 1 lowercase letter</RequirementItem>
        <RequirementItem valid={number}>Must contain at least 1 number</RequirementItem>
        <RequirementItem valid={symbol}>
          Must contain at least 1 symbol:
          <ul>
            <li>{symbolList}</li>
          </ul>
        </RequirementItem>
        <RequirementItem valid={username}>Cannot contain username</RequirementItem>
        <RequirementItem valid={firstName}>Cannot contain first name</RequirementItem>
        <RequirementItem valid={lastName}>Cannot contain last name</RequirementItem>
        <RequirementItem valid={blockedWords}>
          Cannot contain the following words:
          <ul>
            {blockedWordsArray.map((word, index) => {
              return <li key={`blockedWord-${index}`}>{word}</li>;
            })}
          </ul>
        </RequirementItem>
      </RequirementList>
    </div>
  );
};

export default PasswordRequirements;
